import {Card, styled} from '@mui/material';

export const UserHealthCardContainer = styled(Card)`
	&.MuiPaper-elevation {
		${({theme}) => theme.breakpoints.down('lg')} {
			margin: -32px -32px 0;
			background: transparent;
			border-radius: 0;
		}

		${({theme}) => theme.breakpoints.down('sm')} {
			margin: -16px -16px 0;
		}
	}
`;
